/**
 *
 * @module geoProvider
 * @see https://github.bamtech.co/fed-devflow/build#configuration
 *
 */

const deviceFamily = process.env.device_family;
const applicationRuntime = process.env.application_runtime;

let strategy = 'browser';

/**
 *
 * @note device specific GeoProvider implementation
 *
 */
if (deviceFamily === 'node' || deviceFamily === 'apple') {
    strategy = `${deviceFamily}`;
}

/**
 *
 * @note runtime specific GeoProvider implementation
 *
 */
if (applicationRuntime === 'trilithium') {
    strategy = `${deviceFamily}/${applicationRuntime}`;
}

module.exports = require(`./${strategy}/geoProvider`);



// WEBPACK FOOTER //
// ./src/platforms/geoProvider.js